import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_mx548rhbkj: FaireCollectionEntity = {
  token: "pbc_mx548rhbkj",
  type: "collection",
  name: "Vintage Charm Organic Baby Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5a283e19848ad637038e65d245cd7f85ec15d52a42c10ecd211dedcf4a5fe8c6.png",
  itemCount: 14,
  description:
    "Vintage-inspired collection featuring brushed cotton ginghams, classic corduroy accents, delicate hand smocking, and timeless heirloom details for an elegant, nostalgic look.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:17.047Z",
    importedBy: "entity-db-import-collections",
  },
};
